<template>
	<v-container>
		<v-row align="end">
			<v-btn
				large
				class="d-md-none mr-2"
				@click="$emit('update:isDrawerOpen', !isDrawerOpen)"
				icon
				><v-icon>mdi-menu</v-icon></v-btn
			>
			<h2 class="display-1 mr-5">一个空的页面</h2>
			<span class="title">
				你如果有任何建议的话在群内 @Trzeth 就OK了
			</span> </v-row
		><v-row class="mt-12">
			<p class="body-1 ">
				这里本来应该有一个页面，但是我已经把我所有想实现的功能都在首页的搜索框实现了。
				<br />
				我还是把它保留了下来，相信它一定会有变得有用处的那一天。
				<br />
				顺便希望找个设计师。
				<br />
				我不太相信我的审美能力。
			</p>
		</v-row>
		<v-row class="mt-5">
			<h2 class="title">有没有野生的设计师啊啊啊啊啊</h2>
		</v-row>
	</v-container>
</template>

<script>
export default {
	name: "search",
	props: ["isDrawerOpen"]
};
</script>

<style></style>
